import { Component, OnInit } from "@angular/core";
import { Links } from "./links.interface";
import { GetLinksAction } from "./links.actions";
import { Store } from "@ngrx/store";
import { getLinksSelector } from "./links.reducer";
import { MatDialog } from "@angular/material/dialog";
import { LinkAddComponent } from "./link-add/link-add.component";

@Component({
  selector: "app-links",
  templateUrl: "./links.component.html",
  styleUrls: ["./links.component.scss"],
  standalone: false,
})
export class LinksComponent implements OnInit {
  links: Links;

  constructor(
    private store: Store,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetLinksAction());

    this.store.select(getLinksSelector).subscribe((links: Links) => {
      this.links = links;
    });
  }

  showAddForm(): void {
    this.dialog.open(LinkAddComponent, {
      width: "600px",
      disableClose: true,
      panelClass: "app-dialog-panel",
    });
  }
}
